/**
 * News Service for fetching PSC news from WordPress REST API
 */

const PSC_NEWS_API_BASE = "https://psc.gov.ng/wp-json/wp/v2";

/**
 * Fetch latest news from PSC website
 * @param {number} perPage - Number of posts to fetch (default: 3)
 * @returns {Promise<Array>} Array of news articles
 */
export const fetchPSCNews = async (perPage = 3) => {
  try {
    const response = await fetch(
      `${PSC_NEWS_API_BASE}/posts?per_page=${perPage}&_embed&orderby=date&order=desc`
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    return data.map(post => {
      const featuredImage = post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || null;  
      return {
        id: post.id,
        title: post.title.rendered,
        date: new Date(post.date).getTime(),
        link: post.link,
        excerpt: post.excerpt.rendered,
        featuredImage: featuredImage,
        author: post._embedded?.author?.[0]?.name || "PSC Admin",
        category: post._embedded?.["wp:term"]?.[0]?.[0]?.name || "Press Release"
      };
    });
  } catch (error) {
    console.error("Error fetching PSC news:", error);
    throw error;
  }
};

/**
 * Get featured image URL with fallback
 * @param {Object} post - WordPress post object
 * @returns {string|null} Featured image URL or null
 */
export const getFeaturedImageUrl = (post) => {
  if (post._embedded?.["wp:featuredmedia"]?.[0]?.source_url) {
    return post._embedded["wp:featuredmedia"][0].source_url;
  }
  return null;
};

/**
 * Format date for display
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date
 */
export const formatNewsDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
};
